import { useMappedConstants } from "@/app/hooks/useMappedConstants";
import clsx from "clsx";
import { startCase } from "lodash";
import { Tooltip } from "react-tooltip";

const PetName: React.FC<{
  petName: string;
  petStatus: string;
  className?: string;
}> = (props) => {
  const { petStatusColors } = useMappedConstants();
  return (
    <>
      <span
        data-tooltip-content={`Pet ${props?.petName} is ${props?.petStatus}`}
        data-tooltip-id={`${props?.petName}:${props?.petStatus}`}
        className={clsx(props?.className, petStatusColors[props?.petStatus?.toLowerCase()], "text-md")}
      >
        {startCase(props?.petName?.split("_").join(" ")) ?? "Not Available"}
      </span>
      {props?.petStatus !== "" && <Tooltip id={`${props?.petName}:${props?.petStatus}`} style={{ fontSize: "10px" }} />}
    </>
  );
};

export default PetName;
